import AgentManager from './user/AgentManager';
import { useTranslation } from 'react-i18next';

export default function AgentManagement() {
  const { t } = useTranslation();

  return (
    <AgentManager
      title={t('settings.userManagement.title')}
      description={t('settings.userManagement.description')}
    />
  );
}
